{
    "type": {
        "virtual": "Virtual",
        "physical": "Physical"
    },
    "label": {
        "card_holder": "Card holder",
        "monthly_limit": "Monthly Limit",
        "currency": "Currency",
        "atm_withdrawals": "ATM Withdrawals",
        "online_payments": "Online payments",
        "account_statement": "Account statements",
        "funding_history": "Funding history",
        "back_to_credit_card": "Back to card",
        "back_to_credit_cards": "Back to cards",
        "back_to_wallet": "Back to wallet",
        "load_amount": "Load amount",
        "date": "Date",
        "load_type": "Load type",
        "balance_after": "Balance after",
        "month": "Month",
        "opening_balance": "Opening balance",
        "debit": "Debit",
        "credit": "Credit",
        "closing_balance": "Closing balance",
        "download": "Download",
        "documents": "Documents",
        "card_number": "Card number",
        "year": "Year",
        "cvc": "CVC",
        "beneficiary": "Beneficiary",
        "iban": "Iban",
        "bic_number": "Bic number",
        "bank_name": "Bank name",
        "bank_address": "Bank address",
        "limit": "Limit",
        "frequency": "Frequency",
        "transferred_amount": "Amount to be transferred",
        "total_fund": "Total fund",
        "total_expense": "Total expense",
        "card_name": "Card name or description"
    },
    "action": {
        "set_passcode": "Set finway PIN",
        "update_pin": "Update finway PIN",
        "show_pin": "Show Pin",
        "suspend": "Suspend card",
        "resume": "Resume card",
        "close": "Close card",
        "report": "Report card",
        "wallet_funding": "Wallet funding",
        "wallet_funding_via_bank_transfer": "Wallet funding via bank transfer",
        "wallet_details": "Wallet details",
        "create_new": "Issue card",
        "submit": "Issue Card",
        "save_changes": "Save changes",
        "top_up_card": "Top up card",
        "empty_card": "Empty card",
        "enroll_all_users": "Enroll all"
    },
    "edit": {
        "title": "Edit card details",
        "budget": "Budget",
        "budget_frequency": "Budget frequency",
        "transaction_limit": "Transaction Limit",
        "is_atm": "ATM withdrawals",
        "is_auto_recharge": "Auto recharge",
        "is_balance_alert": "Low balance alert",
        "auto_recharge_trigger": "Auto recharge trigger",
        "balance_trigger": "Low balance trigger"
    },
    "title": "KYB (Know your business)",
    "information": "Please fill out the form which is required for the card activation.",
    "information_2": "The verification process can take up to 3 working days.",
    "steps": {
        "company_details": "Company details",
        "directors": "Directors",
        "shareholders": "Shareholders"
    },
    "placeholder": {
        "card_name": "Card for travel purchases",
        "name_on_card": "Cardholder's name on the card"
    },
    "company_details": {
        "company_name": "Company name",
        "trading_name": "Company trading name",
        "establishment_date": "Date of establishment",
        "tax_id": "Tax ID",
        "incorporation_type": "Incorporation type",
        "incorporation_state": "State of incorporation",
        "incorporation_certificate": "Certificate of incorporation",
        "is_public": "Is public or not",
        "yes": "Yes",
        "no": "No",
        "is_payment_provider": "Is payment provider",
        "primary_contact_email": "Email of primary contact",
        "primary_contact_phone": "Mobile number of primary contact",
        "address_company": "Address of the company",
        "address_office": "Office address",
        "street": "Street",
        "street_number": "Street number",
        "city": "City",
        "state": "State",
        "postal_code": "Postal Code",
        "country_code": "Country Code",
        "legal_structure_chart": "Legal structure chart",
        "financial_statement": "Financial statement",
        "memorandum": "Memorandum / Article of association"
    },
    "directors": {
        "title": "Directors or officers",
        "information": "Legal representative information",
        "first_name": "First name",
        "last_name": "Last name",
        "job_title": "Job title",
        "date_of_birth": "Date of birth",
        "street": "Street",
        "street_number": "Street number",
        "city": "City",
        "state": "State",
        "postal_code": "Postal Code",
        "country_code": "Country Code",
        "phone": "Phone number",
        "email": "Email address",
        "is_owner": "Is also beneficial owner",
        "owner": "Yes",
        "not_owner": "No",
        "personal_id": "National ID or driver's license",
        "proof_of_address": "Proof of address",
        "proof_of_address_extra": "Eg., bank statement or utility bill. Must be dated within last 3 months.",
        "add": "Add another beneficial owner",
        "remove": "Remove beneficial owner",
        "date_appointed": "Date appointed",
        "nationality": "Nationality",
        "yes": "Yes",
        "no": "No",
        "is_beneficial_owner": "Is also beneficial owner",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Address of the legal representative",
        "identification": "Identification of the director",
        "identification_type": "Type of the identification document",
        "identification_value": "ID or passport number",
        "identification_type_id": "ID",
        "identification_type_passport": "Passport"
    },
    "shareholders": {
        "information": "Shareholders information",
        "first_name": "First name",
        "last_name": "Last name",
        "job_title": "Job title",
        "date_of_birth": "Date of birth",
        "street": "Street",
        "street_number": "Street number",
        "city": "City",
        "state": "State",
        "postal_code": "Postal Code",
        "country_code": "Country Code",
        "phone": "Phone number",
        "email": "Email address",
        "board_member_since": "Board member since",
        "company_owner_percentage": "Company owner percentage",
        "proof_of_address": "Proof of address",
        "proof_of_address_extra": "Eg., bank statement or utility bill. Must be dated within last 3 months.",
        "share_allotment": "(e.g. share allotment, share certificate issued by the government business registry etc.)",
        "personal_id": "National ID or driver's license",
        "attester_name": "Attester name",
        "attester_title": "Attester title",
        "attestation_date": "Attestation date",
        "official_document": "Official or notarized document of share ownership shows the ultimate shareholders",
        "attestation_consent": "Attestation consent",
        "add": "Add another shareholder",
        "remove": "Remove shareholder",
        "verify_data": "Verify that the above named data is correct",
        "date_appointed": "Date appointed",
        "nationality": "Nationality",
        "yes": "Yes",
        "no": "No",
        "is_beneficial_owner": "Is also beneficial owner",
        "is_proprietor_or_officer": "Is also proprietor or officer",
        "address_of_legal_representative": "Address of the legal representative",
        "identification": "Identification of the director",
        "identification_type": "Type of the identification document",
        "identification_value": "ID or passport number",
        "identification_type_id": "ID",
        "identification_type_passport": "Passport"
    },
    "buttons": {
        "previous": "Previous step",
        "save_for_later": "Save for later",
        "next": "Next step",
        "send": "Send",
        "upload": "Upload"
    },
    "wallet_funding": {
        "credit_card": "Card",
        "bank_transfer": "Bank transfer",
        "card_info": "Card transfers are processed immediately once approved by our team. Please note that a 2% fee will be charged on this operation due to banking fees.",
        "finway_bank_info": "The wallet is your finway bank account, which is linked to your finway cards. You need to have money in the wallet to be able to use the finway cards. You can make bank transfers from your bank account to your finway-Wallet because your bank is connected to finway."
    },
    "card_widget": {
        "balance": "finway-Wallet balance",
        "loaded_sum": "Loaded balance on prepaid cards",
        "pending_transaction": "Pending transaction"
    },
    "frequency": {
        "daily": "Daily",
        "weekly": "Weekly",
        "monthly": "Monthly",
        "quarterly": "Quarterly",
        "yearly": "Yearly",
        "life_time": "Lifetime",
        "one_time": "One-time"
    },
    "kyb_reason": {
        "action_required": "Your KYB request could not be approved because some changes needs to be done.",
        "rejected": "Your KYB request was rejected."
    },
    "incorporation_type": {
        "LLC": "LLC",
        "CORPORATION": "Corporation",
        "SOLE_PROPRIETORSHIP": "Sole Proprietorship",
        "PARTNERSHIP": "Partnership",
        "COOPERATIVE": "Cooperative",
        "OTHER": "Other"
    },
    "show_pin": {
        "title": "Physical card PIN",
        "message": "This is the PIN for the physical finway card."
    },
    "card_onboarding": {
        "title": "Cards program activation",
        "description": "You have been enrolled in your company's cards program. Please complete this onboarding in order to use your card.",
        "passcode": {
            "title": "Setup finway PIN",
            "prompt": "Please set a finway PIN containing four digits."
        },
        "mobile_verification": {
            "title": "Mobile verification",
            "complete": "Your phone number has been verified."
        },
        "complete": "You can now use the finway cards."
    },
    "filter": {
        "all_cards": "All cards",
        "active_cards": "Active cards"
    }
}
